let errorCount = 0;

export default {
  showErrorMessage(error) {
    errorCount++;
    console.error(`[ERROR MIXIN #${errorCount}] Error type:`, error.constructor.name);
    console.error(`[ERROR MIXIN #${errorCount}] Full error object:`, error);
    
    // Scroll to top when showing error messages
    this.scrollToTop(true);
    
    if(error instanceof TypeError){
      console.error(`[ERROR MIXIN #${errorCount}] TypeError caught:`, error);
      console.error(`[ERROR MIXIN #${errorCount}] Error message:`, error.message);
      console.error(`[ERROR MIXIN #${errorCount}] Error stack:`, error.stack);
      this.flash("Oops! Something went wrong. Please Contact Your Service Provider",'error')
      return
    }
    if (error.response.data.exception) {
      this.flash("Oops! Something Went Wrong. Please Try Again Later", 'error');
      return
    }
    if (typeof (error.response.data.message) === 'string') {
      this.flash(
        error.response.data.message,
        "error"
      );
      return
    }
    const failures = error.response.data.message;
    if (failures && typeof failures === 'object') {
      Object.values(failures).forEach((failure) => {
        this.flash(failure, "error");
      });
    } else {
      this.flash("Oops! Something Went Wrong. Please Try Again Later", "error");
    }
  },
}
